import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ISelect {
  value: string;
  label: string;
}

export interface ISpeciesData extends ISelect {
  reportText1?: string;
  commonName?: string;
}

export interface ISpeciesModelOption extends ISelect {
  bucketName: string;
  fileExtension: string;
  originalFileName: string;
}

interface IInitialState {
  loadingMessage: string;
  showGlobalLoading: boolean;
  speciesData: ISpeciesData[];
  selectedSpecies: string | null;
  speciesModelOptions: ISpeciesModelOption[];
  selectedSpeciesModel: string | null;
  isLoggedinUserAdmin: boolean;
  disclaimerAccepted: boolean;
  privacyPolicyAccepted: boolean;
}
const initialState: IInitialState = {
  loadingMessage: 'Loading...',
  showGlobalLoading: false,
  speciesData: [],
  selectedSpecies: null,
  speciesModelOptions: [],
  selectedSpeciesModel: null,
  isLoggedinUserAdmin: false,
  disclaimerAccepted: false,
  privacyPolicyAccepted: false,
};
export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    setShowGlobalLoading: (state, action) => {
      state.showGlobalLoading = action.payload;
    },
    setSpeciesData: (state, action) => {
      state.speciesData = action.payload;
    },
    setSelectedSpecies: (state, action) => {
      state.selectedSpecies = action.payload;
    },
    setSpeciesModelOptions: (state, action) => {
      state.speciesModelOptions = action.payload;
    },
    setSelectedSpeciesModel: (state, action) => {
      state.selectedSpeciesModel = action.payload;
    },
    setIsLoggedinUserAdmin: (state, action) => {
      state.isLoggedinUserAdmin = action.payload;
    },
    setDisclaimerAccepted: (state, action) => {
      state.disclaimerAccepted = action.payload;
    },
    setPrivacyPolicyAccepted: (state, action) => {
      state.privacyPolicyAccepted = action.payload;
    },
  },
});

export const {
  setLoadingMessage,
  setShowGlobalLoading,
  setSpeciesData,
  setSelectedSpecies,
  setSpeciesModelOptions,
  setSelectedSpeciesModel,
  setIsLoggedinUserAdmin,
  setDisclaimerAccepted,
  setPrivacyPolicyAccepted,
} = appSlice.actions;

export const loadingMessageSelector = (state: RootState) => state.appSlice.loadingMessage;
export const showGlobalLoadingSelector = (state: RootState) => state.appSlice.showGlobalLoading;
export const speciesDataSelector = (state: RootState) => state.appSlice.speciesData;

export const selectedSpeciesSelector = (state: RootState) => state.appSlice.selectedSpecies;
export const speciesModelOptionsSelector = (state: RootState) => state.appSlice.speciesModelOptions;
export const selectedSpeciesModelSelector = (state: RootState) => state.appSlice.selectedSpeciesModel;
export const isLoggedinUserAdminSelector = (state: RootState) => state.appSlice.isLoggedinUserAdmin;

export const disclaimerAcceptedSelector = (state: RootState) => state.appSlice.disclaimerAccepted;
export const privacyPolicyAcceptedSelector = (state: RootState) => state.appSlice.privacyPolicyAccepted;

export default appSlice.reducer;
